import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'success' | 'disabled';
  size?: 'sm' | 'md' | 'lg';
}

function Button({ children, variant = 'primary', size = 'md', className = '', ...props }: ButtonProps) {
  const variantClasses =
    variant === 'primary'
      ? 'text-white'
      : variant === 'secondary'
        ? 'bg-slate-600 text-white hover:bg-slate-700'
        : variant === 'outline'
          ? 'bg-white border text-[color:var(--besty-slate-700)] hover:bg-gray-50'
          : variant === 'success'
            ? 'text-white'
            : 'text-white cursor-not-allowed';

  const sizeClasses =
    size === 'lg' ? 'px-5 py-3 text-base' : size === 'sm' ? 'px-3 py-1.5 text-sm' : 'px-4 py-2 text-sm';
  const base = 'rounded-md shadow-sm transition-colors';

  const isDisabled = props.disabled as boolean;

  const style: React.CSSProperties =
    variant === 'primary'
      ? { backgroundColor: isDisabled ? 'var(--besty-blue-disabled)' : 'var(--besty-blue)' }
      : variant === 'outline'
        ? { borderColor: 'var(--besty-gray-300)' }
        : variant === 'success'
          ? { backgroundColor: isDisabled ? 'var(--besty-blue-disabled)' : 'var(--besty-blue)' }
          : { backgroundColor: 'var(--besty-blue-disabled)' };

  return (
    <button
      className={[base, variantClasses, sizeClasses, className].filter(Boolean).join(' ')}
      style={style}
      onMouseOver={(e) => {
        if ((variant === 'primary' || variant === 'success') && !isDisabled) {
          e.currentTarget.style.backgroundColor = 'var(--besty-blue-hover)';
        }
      }}
      onMouseOut={(e) => {
        if ((variant === 'primary' || variant === 'success') && !isDisabled) {
          e.currentTarget.style.backgroundColor = 'var(--besty-blue)';
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
